import type { NotificationListDto } from '@an-crm/shared';
import { queryOptions } from '@tanstack/react-query';
import { api } from '@/lib/api/client';

export const notificationKeys = {
  all: ['me', 'notifications'] as const,
};

export const NOTIFICATIONS_LIMIT = 20;

export const notificationsQuery = queryOptions({
  queryKey: notificationKeys.all,
  queryFn: ({ signal }) =>
    api<NotificationListDto>('/me/notifications', { query: { limit: NOTIFICATIONS_LIMIT }, signal }),
  // realtime pushes invalidate this; polling is only a safety net when the socket is down
  refetchInterval: 120_000,
});

export const notificationsApi = {
  markRead: (id: string) => api<void>(`/me/notifications/${encodeURIComponent(id)}/read`, { method: 'POST' }),
  markAllRead: () => api<void>('/me/notifications/read-all', { method: 'POST' }),
};
